<template>
  <div id="pagenotfound">
    <h1>見つからないエラー</h1>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PageNotFound.vue